import { connect } from 'react-redux'

import TabQuotationPO from './units'

const mapStateToProps = state => {
  let firstInvoice = 0
  let secondInvoice = 0

  if (state.ProjectPaymentConfirmation.invoices.rows.length) {
    firstInvoice = state.ProjectPaymentConfirmation.invoices.rows[0]
    if (state.ProjectPaymentConfirmation.invoices.rows.length > 1) {
      secondInvoice = state.ProjectPaymentConfirmation.invoices.rows[1]
    }
  }
  return {
    po: state.ProjectDetail.po,
    poData: state.ProjectDetail.po.rows,
    projectInvoices: state.ProjectPaymentConfirmation.invoices.rows,
    firstInvoice,
    secondInvoice,
    invoices: state.ProjectPaymentConfirmation.invoices.rows,
    invoiceStatusWaitingConfirmation:
      state.Reference.invoiceStatus.waitingConfirmation.status,
    invoiceStatusWaitingConfirmed: state.Reference.invoiceStatus.confirmed.status,
    invoiceStatusRejected: state.Reference.invoiceStatus.rejected.status,
    invoiceStatus: state.Reference.invoiceStatus,
    paymentLog: state.ProjectDetail.paymentLog,
    projectDetail: state.ProjectDetail.data,
  }
}

export default connect(mapStateToProps)(TabQuotationPO)
